import { Pipe, PipeTransform } from '@angular/core';
import * as numeral from 'numeral';

@Pipe({
    name: 'numberFormat'
})
export class NumberFormatPipe implements PipeTransform {
    transform(value: number, format?: string): string {
        return numeral(value).format(format?format:'0,0.00');
    }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/pipes/number-format.pipe.ts